import { gql } from '@apollo/client'

export const GET_ROUNDS = gql`
  query FetchSeriesRounds($input: oSeriesIdInput) {
    fetchSeriesRounds(input: $input) {
      _id
      sName
    }
  }
`

export const GET_STANDING_DATA = gql`
  query FetchSeriesStandings($input: oSeriesStandingsInput) {
    fetchSeriesStandings(input: $input) {
      bIsTeamQualified
      _id
      dUpdated
      oRecentTeamMatches {
      oOpponent {
        sTitle
        sAbbr
        iTeamId
      }
      iWinnerId  
      sResult
      sDescription
      dStartDate
    }
      oRound {
        _id
        iSeriesId
        nOrder
        sName
      }
      iSeriesId
      oTeam {
        _id
        sAbbr
        sTitle
        oSeo {
          sSlug
          eStatus
        }
        eTagStatus
      }
      nDraw
      nLoss
      nNR
      nNetrr
      nOverAgainst
      nOverFor
      nPlayed
      nPoints
      nRunAgainst
      nRunFor
      nWin
      sLastFiveMatchResult
      oSeries {
        sSeriesType
      }
    }
  }
`
